import React from 'react';
import { cn } from '../../../utils/cn';

export type StepKey = 'pick' | 'upload' | 'review' | 'result';

interface StepperProps {
  current: StepKey;
  labels: Record<StepKey, string>;
}

const ORDER: StepKey[] = ['pick', 'upload', 'review', 'result'];

export const Stepper: React.FC<StepperProps> = ({ current, labels }) => {
  const currentIdx = ORDER.indexOf(current);
  return (
    <ol className="flex items-center gap-3 text-xs">
      {ORDER.map((key, i) => {
        const state = i < currentIdx ? 'done' : i === currentIdx ? 'active' : 'todo';
        return (
          <li key={key} className="flex items-center gap-2">
            <span
              className={cn(
                'inline-flex h-6 w-6 items-center justify-center rounded-full border text-[11px] font-semibold',
                state === 'done' && 'border-primary-600 bg-primary-600 text-white',
                state === 'active' && 'border-primary-600 text-primary-700',
                state === 'todo' && 'border-gray-300 text-gray-400',
              )}
            >
              {i + 1}
            </span>
            <span
              className={cn(
                'whitespace-nowrap',
                state === 'active' ? 'font-semibold text-gray-900' : 'text-gray-500',
              )}
            >
              {labels[key]}
            </span>
            {i < ORDER.length - 1 && <span className="mx-1 h-px w-6 bg-gray-200" />}
          </li>
        );
      })}
    </ol>
  );
};
